import {Component, OnDestroy, OnInit} from '@angular/core';
import {TlPagination} from "../../interfaces/general-interfaces";
import {NotificationsHttpService} from "../../services/http-services/notifications/notifications-http.service";
import {isToday, subDays} from "date-fns";
import {KeyValuePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {TimeAgoPipe} from "../../pipes/time-ago/time-ago.pipe";
import {
  HandleShowNotificationImagePipe
} from "../../pipes/handle-show-notification-image/handle-show-notification-image.pipe";
import {NotificationSubTypesEnums, NotificationTypesEnums} from "../../enums/notification-enums";
import {PAGES_AND_PATHS} from "../../constants/pages-and-paths";
import {Router, RouterLink} from "@angular/router";
import {UserRoles} from '../../enums/general-enums';
import {CheckActiveRoleModule} from '../../pipes/check-active-role/check-active-role.module';

@Component({
  selector: 'tl-notifications',
  standalone: true,
  imports: [
    NgIf,
    KeyValuePipe,
    TimeAgoPipe,
    HandleShowNotificationImagePipe,
    NgForOf,
    NgClass,
    RouterLink,
    CheckActiveRoleModule
  ],
  templateUrl: './notifications.component.html',
})
export class NotificationsComponent implements OnInit, OnDestroy {
  notifications: any[] = [];
  notificationGroups: any[] = [];
  urlParams = {page: 1};
  notificationsPagination: TlPagination | undefined;
  constructor(private notificationsHttpService: NotificationsHttpService,
              private router: Router) { }

  ngOnInit(): void {
    this.notifications = [];
    this.notificationsPagination = undefined;
    this.getNotifications();
  }

  ngOnDestroy(): void {
    this.notificationsHttpService.postMarkAllNotificationsAsRead();
  }

  getNotifications(): void {
    this.urlParams.page = this.notificationsPagination?.currentPage ? this.notificationsPagination.currentPage + 1 : 1;
    this.notificationsHttpService.getNotifications(this.urlParams).then(res => {
      this.notifications = [...this.notifications, ...res.data];
      this.groupNotifications(this.notifications);
      this.notificationsPagination = res.pagination;
    });
  }

  groupNotifications(notifications: any[]): void {
    const now = new Date();
    const sevenDaysAgo = subDays(now, 7);
    const thirtyDaysAgo = subDays(now, 30);
    const groups: { [key: string]: any[] } = {};
    notifications.forEach(notification => {
      const createdAt = new Date(notification.created_at);
      let group: string;

      if (isToday(createdAt) && notification.read_at === null) {
        group = 'New';
      } else if (isToday(createdAt) && notification.read_at !== null) {
        group = 'Today';
      } else if (createdAt >= sevenDaysAgo) {
        group = 'Last 7 days';
      } else if (createdAt >= thirtyDaysAgo) {
        group = 'Last 30 days';
      } else {
        group = 'Older';
      }

      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(notification);
    });

    this.notificationGroups = Object.entries(groups).map(([title, notifications]) => ({
      title,
      notifications
    }));
  }

  notificationRedirect(notification: any): void {
    if (notification.type === NotificationTypesEnums.newLike && notification.data.like.likeable_type === NotificationSubTypesEnums.postSubType) {
      this.router.navigate([PAGES_AND_PATHS.singlePost.pagePath, notification.data.like.likeable.id]);
    }

    if (notification.type === NotificationTypesEnums.newComment && notification.data.comment.commentable_type === NotificationSubTypesEnums.postSubType) {
      this.router.navigate([PAGES_AND_PATHS.singlePost.pagePath, notification.data.comment.commentable.id]);
    }
    if (notification.data.type === 'comment' && notification.data.sub_type === 'post') {
      this.router.navigate([PAGES_AND_PATHS.singlePost.pagePath, notification.data.sub_likeable_id]);
    }

    if (notification.type === NotificationTypesEnums.newComment && notification.data.comment.commentable_type === NotificationSubTypesEnums.reviewSubType) {
      this.router.navigate(['/single-review', notification.data.comment.commentable.review_model_type, notification.data.comment.commentable.reviewable_id, notification.data.comment.commentable.id]);
    }

    if (notification.type === NotificationTypesEnums.newComment && notification.data.comment.commentable_type === NotificationSubTypesEnums.reviewSubType) {
      this.router.navigate(['/lists/my-lists/my_lists/single-list', notification.data.comment.commentable.id]);
    }

    if (notification.type === NotificationTypesEnums.newFollower) {
      this.router.navigate(['/profile', notification.data.from.username]);
    }
  }

  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;

    if (position > height - threshold && (this.notificationsPagination?.currentPage ?? 0) < (this.notificationsPagination?.lastPage ?? 0)) {
      this.getNotifications();
    }
  }

  protected readonly NotificationTypesEnums = NotificationTypesEnums;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly UserRoles = UserRoles;
}
